export class GameActions {
    // space bar
    static ActionSpinOrStop: string = "SPIN_OR_STOP";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/GameActions.ts
 **/